mutation PurchaseOrderAccountingStamper(
  $input: PurchaseOrderAccountingStamperInput!
) {
  purchaseOrderAccountingStamper(input: $input) {
    purchaseOrder {
      id
      _accountingStampDate
      _accountingStampUserId
      _accountingStampUserName
      _accountingStampTransactionReference
    }
  }
}
